import { changeRegister, updateOutlet, updateRegister } from "../../Actions/General/LocationActions";
import { fetchNotifications } from "../../Actions/Notifications/NotificationActions";
import { getOption, type OptionSubscriberCallback, subscribeToOption } from "../../Utilities/Platform/Options/Options";
import { Application } from "../Application";
import { Bootstrapper } from "../Bootstrapper";
import type { ShopfrontDispatch } from "../hooks";

export class LocationBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public bootstrap(): MaybePromise<void> {
        let locationTimeout: ReturnType<typeof setTimeout> | null = null;
        const store = Application.get("Redux");

        /**
         * Update the location from an option change
         */
        const updateLocation: OptionSubscriberCallback<"outlet" | "register" | "global_mode"> = (
            option,
            value,
            oldValue
        ) => {
            // If oldValue is undefined (from outlet or register changed, not register_kicked)
            // then ignore the update as we've just specified it for the first time
            if(typeof oldValue === "undefined") {
                return;
            }

            // Ignore same value
            if(value === oldValue) {
                return;
            }

            // Ignore recent register kicks
            if(option === "register" && value === null && getOption("register_kicked") !== null) {
                return;
            }

            // Remove previous queued location update
            if(locationTimeout) {
                clearTimeout(locationTimeout);
            }

            // Queue location update
            locationTimeout = setTimeout(() => {
                if(option === "outlet") {
                    (store.dispatch as ShopfrontDispatch)(updateOutlet(value as string));
                } else if(option === "register") {
                    (store.dispatch as ShopfrontDispatch)(updateRegister(value as string));
                } else if(option === "global_mode") {
                    (store.dispatch as ShopfrontDispatch)(changeRegister(value ? "global" : undefined));
                }

                (store.dispatch as ShopfrontDispatch)(fetchNotifications());
            }, 100);
        };

        // Subscribe to updating location
        subscribeToOption("outlet", updateLocation);
        subscribeToOption("register", updateLocation);
        subscribeToOption("global_mode", updateLocation);
        subscribeToOption("register_kicked", (_, newValue, oldValue) => {
            if(newValue === null && oldValue !== null) {
                updateLocation("register", oldValue, false);
            }
        });
    }
}
